import React from 'react';
import { billingRecoveryCopy } from '../../lib/billingRecoveryCopy';
import type { useBillingRecoveryAction } from '../../hooks/useBillingRecoveryAction';
import './BillingRecoveryPanel.css';

interface BillingRecoveryPanelProps {
  lang: string;
  action: ReturnType<typeof useBillingRecoveryAction>;
}

export default function BillingRecoveryPanel({ lang, action }: BillingRecoveryPanelProps) {
  const copy = billingRecoveryCopy(lang);
  return (
    <section className="billing-recovery-panel" aria-label={copy.title}>
      <h2>{copy.title}</h2>
      <p>{copy.detail}</p>
      {action.error && <p className="billing-recovery-panel__error" role="alert">{copy.error}</p>}
      <button type="button" onClick={action.openBilling} disabled={!action.enabled || action.busy}>
        {action.busy ? copy.busy : copy.cta}
      </button>
    </section>
  );
}
